import { render, staticRenderFns } from "./PlayerResourceLogCopy.vue?vue&type=template&id=1459fb60&"
import script from "./PlayerResourceLogCopy.vue?vue&type=script&lang=js&"
export * from "./PlayerResourceLogCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports